import { setup, draw } from './sketch.js';
import { make } from '../js/infra.js';
import fs from 'fs';

const source = fs.readFileSync(__dirname + '/sketch.js', 'utf8');
make({ setup, draw }, source);
